<div class="cv-modal-container">
  <!-- Profile Header -->
  <ng-container *ngIf="!showPersonalInfoStep">
    <div class="profile-header">
      <img [src]="data?.profileImage || profileImagePreviewUrl" alt="Profile Picture"/>
      <div>
        <h2>{{ data?.firstname }} &nbsp; {{ data?.lastname }}</h2>
        <p>{{ data?.location }}</p>
      </div>
    </div>
  </ng-container>

  <!-- Step Tabs -->
  <div class="steps-tabs">
    <div style="color: black;" *ngFor="let step of steps; let i = index"
         [class.active]="i === currentStep"
         (click)="currentStep = i">
      <img src="assets/step-base.png" alt="step icon" class="step-icon"/>
      {{ step | translate }}
    </div>
  </div>

  <!-- Step Content -->
  <div class="step-content">
    <div style="padding: 1rem;">
      <app-banner [icon]="'assets/icons/info.png'" [color]="'#F0F6FF'"
                  [text]="'cv_modal.banner_info' | translate">
      </app-banner>
    </div>

    <ng-container [ngSwitch]="currentStep">
      <!-- Personal Information -->
      <ng-container *ngIf="showPersonalInfoStep && currentStep === 0">
        <div style="padding: 2rem;">
          <h3>{{ 'cv_modal.steps.personal_info' | translate }}</h3>


          <app-dropdown
            [items]="countries"
            bindLabel="name"
            bindValue="name"
            [clearable]="false"
            [multiple]="false"
            [(ngModel)]="selectedCountry"
            placeholder="{{ 'login_page.choose_country' | translate }}"
          >
            <ng-template #optionTpl let-country>
              <div class="option">
                <img
                  [src]="getFlagSrc(country)"
                  [alt]="(country?.name ?? country) + ' flag'"
                  class="flag"
                  style="width:1rem;height:1rem;border-radius:2px;margin-right:.5rem;"
                />
                <span>{{ country?.name ?? country }}</span>
              </div>
            </ng-template>

            <ng-template #selectedItemTpl let-country>
              <div class="selected-item">
                <img
                  [src]="getFlagSrc(country)"
                  [alt]="(country?.name ?? country) + ' flag'"
                  class="flag"
                  style="width:1rem;height:1rem;border-radius:2px;margin-right:.5rem;"
                />
                <span>{{ country?.name ?? country }}</span>
              </div>
            </ng-template>
          </app-dropdown>


          <div class="upload-container" style="margin-top: 1rem;">
            <app-upload-image (fileChange)="setImageFile($event)" [isFromCourseModal]="true"></app-upload-image>
          </div>
        </div>
      </ng-container>

      <!-- Bio Section -->
      <div style="padding: 2rem;" *ngSwitchCase="showPersonalInfoStep ? 1 : 0">
        <h3>{{ 'cv_modal.steps.bio' | translate }}</h3>
        <textarea [(ngModel)]="data.bio" class="bio-textarea"></textarea>
      </div>

      <!-- Work Experience -->
      <div *ngSwitchCase="showPersonalInfoStep ? 2 : 1">
        <div *ngFor="let job of workExperience; let j = index" class="section">
          <div class="two-columns">
            <app-input [(ngModel)]="job.organization" [placeholder]="'cv_modal.work.company' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
            <app-input [(ngModel)]="job.jobTitle" [placeholder]="'cv_modal.work.title' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>

          <div class="two-columns">
            <app-input [(ngModel)]="job.startDate" type="date" [placeholder]="'cv_modal.work.start_date' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
            <app-input [(ngModel)]="job.completionDate" type="date"
                       [placeholder]="'cv_modal.work.completion_date' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>

          <app-input-area [isEditable]="true" [defaultText]="job.jobDescription" [withSubmit]="false"
                          [placeholder]="'cv_modal.work.description' | translate"
                          (text)="job.jobDescription = $event"></app-input-area>

          <div class="two-columns">
            <app-input [(ngModel)]="job.location" [placeholder]="'cv_modal.work.location' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>


          <app-button (click)="removeItem(workExperience, j)" [label]="'cv_modal.actions.remove' | translate"
                      [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR"
                      [type]="ButtonType.SECONDARY"></app-button>
        </div>
        <div style="padding-right: 1rem; padding-left: 1rem;">

          <app-button (click)="addWorkExperience()" [label]="'cv_modal.actions.add' | translate"
                      [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR"
                      [type]="ButtonType.SECONDARY"></app-button>
        </div>
      </div>
      <!-- Education -->
      <div *ngSwitchCase="showPersonalInfoStep ? 3 : 2">
        <div *ngFor="let edu of education; let i = index" class="section">
          <div class="two-columns">
            <app-input [(ngModel)]="edu.education" [placeholder]="'cv_modal.education.degree' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
            <app-input [(ngModel)]="edu.organization" [placeholder]="'cv_modal.education.institution' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>

          <div class="two-columns">
            <app-input [(ngModel)]="edu.startDate" type="date"
                       [placeholder]="'cv_modal.education.start_date' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
            <app-input [(ngModel)]="edu.completionDate" type="date"
                       [placeholder]="'cv_modal.education.completion_date' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>

          <div class="two-columns">
            <app-input [(ngModel)]="edu.location" [placeholder]="'cv_modal.education.location' | translate"
                       [size]="InputSize.LARGER" [state]="InputState.REGULAR" [withNoIcon]="true"></app-input>
          </div>

          <app-button (click)="removeItem(education, i)" [label]="'cv_modal.actions.remove' | translate"
                      [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR"
                      [type]="ButtonType.SECONDARY"></app-button>
        </div>

        <div style="padding-right: 1rem; padding-left: 1rem;">
          <app-button (click)="addEducation()" [label]="'cv_modal.actions.add' | translate"
                      [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR"
                      [type]="ButtonType.SECONDARY"></app-button>
        </div>
      </div>

      <!-- Language -->
      <div *ngSwitchCase="showPersonalInfoStep ? 4 : 3" style="padding: 1rem;">

        <app-dropdown
          [items]="languages"
          bindLabel="name"
          bindValue="name"
          [clearable]="false"
          [multiple]="true"
          [formControl]="languageCtrl"
          placeholder="{{ 'login_page.select_language' | translate }}"
        >

          <ng-template #optionTpl let-language>
            <div class="language-option" style="display:flex;align-items:center;gap:.5rem;">
              <img
                [src]="getFlagSrc(language?.name ?? language)"
                [alt]="(language?.name ?? language) + ' flag'"
                style="width:1rem;height:1rem;border-radius:2px;"
              />
              <span>{{ language?.name ?? language }}</span>
            </div>
          </ng-template>
        </app-dropdown>

        <mat-chip-set class="selected-language-set">
          <mat-chip *ngFor="let language of selectedLanguages"
                    removable="true"
                    (removed)="removeLanguage(language)"
                    class="language-chip">

            <div class="chip-content">
              <div class="left-content">
                <img [src]="getFlagSrc(language)" class="flag-icon" alt="{{ language }} flag"/>
                <span class="language-name">{{ language }}</span>
              </div>
              <button matChipRemove class="remove-btn">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </mat-chip>

        </mat-chip-set>
      </div>
    </ng-container>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <app-button (click)="onCancel()" [label]="'cv_modal.actions.cancel' | translate"
                [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR" [type]="ButtonType.GHOST"></app-button>

    <app-button *ngIf="currentStep > 0" (click)="goPreviousStep()" [label]="'cv_modal.actions.back' | translate"
                [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR" [type]="ButtonType.GHOST"></app-button>

    <app-button *ngIf="currentStep < steps.length - 1" (click)="goNextStep()"
                [label]="'cv_modal.actions.next' | translate"
                [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR" [type]="ButtonType.PRIMARY"></app-button>

    <app-button *ngIf="currentStep === steps.length - 1" (click)="onSave()"
                [label]="'cv_modal.actions.save_continue' | translate"
                [size]="ButtonSize.MEDIUM" [state]="ButtonState.REGULAR" [type]="ButtonType.PRIMARY"></app-button>
  </div>
</div>
